import { faCircleInfo } from "@fortawesome/pro-duotone-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Grid2, Tooltip, useTheme } from "@mui/material"
import { FormLabelContext } from "@ngt/opms"
import { FC, ReactNode, useContext, useMemo } from "react"

interface ILabelWithTooltipProps {
    label?: ReactNode;
    content: string;
}

export const LabelWithTooltip: FC<ILabelWithTooltipProps> = ({
    label,
    content
}) => {
    const { label: contextLabel } = useContext(FormLabelContext);
    const theme = useTheme();
    const labelToUse = useMemo(() => label ?? contextLabel, [label, contextLabel]);
    return (
        <Grid2
            container
            spacing={2}
            alignItems={"center"}
        >
            {labelToUse}
            <Tooltip
                title={content}
            >
                <FontAwesomeIcon 
                    icon={faCircleInfo} 
                    color={theme.palette.primary.light}
                    cursor={"pointer"}
                />
            </Tooltip>
        </Grid2>
    )
}

export default LabelWithTooltip